import type { ReactNode } from 'react';

type CardProps = {
  title?: string;
  action?: ReactNode;
  className?: string;
  children: ReactNode;
};

export function Card({ title, action, className = '', children }: CardProps) {
  return (
    <div className={`rounded-2xl border border-border-default bg-bg-surface p-5 ${className}`}>
      {(title || action) && (
        <div className="mb-5 flex items-center justify-between">
          {title && <h2 className="text-base font-semibold text-text-primary">{title}</h2>}
          {action}
        </div>
      )}
      {children}
    </div>
  );
}
